import { render, staticRenderFns } from "./ReportCandidatesDialog.vue?vue&type=template&id=a6a20e44"
import script from "./ReportCandidatesDialog.vue?vue&type=script&lang=js"
export * from "./ReportCandidatesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports